module.exports = __webpack_public_path__ + "resources/img/img_xcloud_en.802d5b5a7d73a74f4fb3cf02819e7e0b.png";